import React, {useState} from 'react'
import PropTypes from 'prop-types'
import { walletPaymentsName } from 'config/index'
import PubSub from 'services/PubSub'
import TagManagerService from 'services/TagManager'
import WalletService from 'services/Wallet'
import PaymentMethodPrimeItem from './PaymentMethodPrimeItem'
import NewRelicService from 'services/NewRelic'
import TitleWithBar from 'components/TitleWithBar'
import style from './style.scss' //NOSONAR

const PaymentMethodPrimeList = (props) => {
    const { cardsList, isLoading, setLoading, callbackOnClick, callbackChangeView } = props

    const [selectedCard, setSelectedCard] = useState('')

    const oneClick = walletPaymentsName.oneClick;
    const debitOneClick = walletPaymentsName.debitOneClick;
    let pathName = window.location.pathname;

    const callbackSelected = (card) => {
        if (!card) return false
        setSelectedCard(card.token)
        callbackOnClick(card)
    }

    const callbackDelete = (card) => {
        NewRelicService.sendPageAction({
            action: 'deleteCard',
            payload: {
                status: 'init',
            },
        })

        if(card.paymentMethod !== oneClick){
            TagManagerService.interaction('Step 1: Clic botón eliminar tarjeta', pathName, 'Eliminar tarjeta')
        }
        if(card.paymentMethod === oneClick){
            TagManagerService.interaction('Step 1: Clic botón eliminar tarjeta', pathName, 'Eliminar tarjeta')
        }

        if(card.paymentMethod === debitOneClick){
            TagManagerService.interaction('Step 1: Clic botón eliminar tarjeta', pathName, 'Eliminar tarjeta')
        }
        
        PubSub.dispatch('modal_confirmation_open', {
            message: `<div class="modal-cards-list-confirmation-text">
                        <span class="modal-cards-list-title">Eliminar tarjeta</span>
                        <span class="modal-cards-list-subtitle">¿Quieres eliminar la tarjeta seleccionada?</span>
                    <div>`,
            cancelBtnText: 'Cancelar',
            confirmBtnText: 'Eliminar',
            viewHeader: true,
            confirmCallback: () => {
                NewRelicService.sendPageAction({
                    action: 'deleteCard',
                    payload: {
                        status: 'confirm',
                    },
                })
                setLoading(true)
                if (card) {
                    WalletService.deleteWalletCard(card.token).then((data) => {
                        if (data && data.results) {
                            PubSub.dispatch('delete_card', data.results)
                            if(card.paymentMethod !== oneClick && card.paymentMethod !== debitOneClick){
                                TagManagerService.interaction('Step 2: tarjeta eliminada con éxito', 'Tarjeta cencosud', 'Eliminar tarjeta')
                            }
                            if(card.paymentMethod === oneClick){
                                TagManagerService.interaction('Step 2: tarjeta eliminada con éxito', 'Tarjeta de credito', 'Eliminar tarjeta')
                            }

                            if(card.paymentMethod === debitOneClick && card.brand !== 'Prepago'){
                                TagManagerService.interaction('Step 2: tarjeta eliminada con éxito', 'Tarjeta de debito', 'Eliminar tarjeta')
                            }
                            if(card.brand === 'Prepago') {
                                TagManagerService.interaction('Step 2: tarjeta eliminada con éxito', 'Tarjeta prepago', 'Eliminar tarjeta')
                            }
                            NewRelicService.sendPageAction({
                                action: 'deleteCard',
                                payload: {
                                    status: 'success',
                                },
                            })
                            setTimeout(() => {
                                PubSub.dispatch('open_snackbar', {
                                    TitleMobile: 'La tarjeta seleccionada ha sido eliminada de tus medios de pago',
                                    TitleDesktop: `La tarjeta seleccionada ha sido eliminada de tus medios de pago`,
                                    timer: 15000,
                                    type: 'cardListDelete',
                                })
                            }, 0)
                        } else {
                            if (data.status === 401) {
                                NewRelicService.sendPageAction({
                                    action: 'deleteCard',
                                    payload: {
                                        status: 'fail',
                                    },
                                })
                                setTimeout(() => {
                                    setLoading(false)
                                    PubSub.dispatch('open_snackbar', {
                                        TitleMobile:
                                            'Puedes eliminar tu tarjeta una vez que tu pedido haya sido recolectado y la boleta haya sido emitida.',
                                        TitleDesktop: `Puedes eliminar tu tarjeta una vez que tu pedido haya sido recolectado y la boleta haya sido emitida.`,
                                        timer: 15000,
                                        titleButtonMobile: 'Cerrar',
                                        titleButtonDesktop: 'Cerrar',
                                        type: 'cardListError',
                                        callback: () => {},
                                    })
                                }, 0)
                            } else if (data.status >= 500) {
                                setTimeout(() => {
                                    PubSub.dispatch('open_snackbar', {
                                        TitleMobile: 'Tu tarjeta no ha podido ser eliminada, intenta nuevamente',
                                        TitleDesktop: `Tu tarjeta no ha podido ser eliminada, intenta nuevamente`,
                                        timer: 15000,
                                        titleButtonMobile: 'Recargar',
                                        titleButtonDesktop: 'Recargar',
                                        type: 'cardListError',
                                        callback: () => {
                                            if (typeof window !== 'undefined') window.location.reload()
                                        },
                                    })
                                }, 0)
                            }
                        }
                    })
                }
            },
        })
    }

    const getListCards = () => {
        if (!(cardsList && cardsList.length)) return []
        return cardsList.filter((card) => {
            return card.paymentMethod !== walletPaymentsName.debitOneClick
        })
    }

    const callbackSetCheckbox = (_card) => {
        setSelectedCard(_card)
    }

    const listCards = getListCards()
    const setHasChecked = (card) => {
        if (card.isFavorite && !selectedCard) {
            return true
        } else if (selectedCard && selectedCard === card.token) {
            return true
        } else {
            return false
        }
    }

    if (isLoading) return ''

    return (
        <>
            <TitleWithBar title="Mis tarjetas" />
            <div className="payment-method-prime-change-view-button-wrapper">
                <button className="new-link payment-method-prime-change-view-button" onClick={callbackChangeView}>Cambiar medio de pago</button>
            </div>
            {listCards && listCards.length !== 0 && (
                <div className={'payment-method-prime-list' + (listCards && listCards.length < 3 ? ' min-card' : '')}>
                    {listCards &&
                        !!listCards.length &&
                        listCards.map((item, i) => {
                            return (
                                <PaymentMethodPrimeItem
                                    key={i}
                                    card={item}
                                    callbackSelected={callbackSelected}
                                    unique={listCards.length == 1}
                                    callbackDelete={callbackDelete}
                                    callbackSetCheckbox={callbackSetCheckbox}
                                    isChecked={setHasChecked(item)}
                                />
                            )
                        })}
                </div>
            )}
        </>
    )
}

PaymentMethodPrimeList.propTypes = {
    isDebit: PropTypes.bool,
    isLoading: PropTypes.bool,
    setLoading: PropTypes.func,
    cardsList: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
    informativeText: PropTypes.node,
}

export default PaymentMethodPrimeList
